module.exports = __webpack_public_path__ + "static/media/img-app-qrcode.e0bc3eb8.svg";